module.exports = __webpack_public_path__ + "img/chill-hop.793d0e1b.gif";